export var UserStatus;

(function (UserStatus) {
  UserStatus["ACTIVE"] = "active";
  UserStatus["PAST_DUE"] = "past_due";
})(UserStatus || (UserStatus = {}));